import React from "react";
import apstyles from '../styles/app.module.css';
import videoPlayer from "./VideoPlayer";
import data from "../json/videos.json";
function VideoPoster({area, setVideoToPlay, setIsModal, title}) {

   const [items,setItems] = React.useState([]);
    const [filteredItems, setFilteredItems]= React.useState([])
    React.useEffect(() => {
        setItems(data.videos);

    }, [data.videos]);

    React.useEffect(() => {
        const matchingVideos = data.videos.filter(video => {
            return area === `${video.category}`;
        });

        setFilteredItems(matchingVideos);
    }, [data.videos, area]);


     const posterpath = "files/public/pagevideos/poster/";

  const handleVideoToPlay = (item) =>

    {
            setVideoToPlay({ videoid: item });

        setIsModal(true);

    }


    return (
        <section className={apstyles.posterliste}>



            {
                filteredItems.map((item) => (
                    <section key={item.id} className={apstyles.posteritem}>
                        <img src={`${posterpath}${item.id}.jpg`} alt="" loading="lazy"
                        onClick={

                            ()=>handleVideoToPlay(item.id)
                        }


                        />
                    </section>
                ))
            }
        </section>
    );
}

export default VideoPoster;
